class OnEnrolledMessagePayload {
  constructor(buyables, purchasePrice) {
    this.buyables = void 0;
    this.purchasePrice = void 0;
    this.buyables = buyables;
    this.purchasePrice = purchasePrice;
  }
  toJSON() {
    var _this$purchasePrice$p, _this$purchasePrice$p2;
    return JSON.stringify({
      buyables: this.buyables,
      purchasePrice: (_this$purchasePrice$p = (_this$purchasePrice$p2 = this.purchasePrice.price) === null || _this$purchasePrice$p2 === void 0 ? void 0 : _this$purchasePrice$p2.toString()) !== null && _this$purchasePrice$p !== void 0 ? _this$purchasePrice$p : ''
    });
  }
}
export class OnEnrolledMessage {
  constructor(buyables, purchasePrice) {
    this.methodName = 'onEnrolled';
    this.payload = void 0;
    this.payload = new OnEnrolledMessagePayload(buyables, purchasePrice);
  }

  /**
   * Send both the legacy onEnrolledAdditionalData message and the new OnEnrolledMessage until Android
   * adoption is significant enough to full deprecate the onEnrolledAdditionalData call
   * Note: onEnrolledAdditionalData call is not sent to iOS clients; it's only for Android backwards compatibility
   */
  sendLegacyAndroidMessage(client) {
    if (typeof client.onEnrolledAdditionalData === 'function') {
      client.onEnrolledAdditionalData(JSON.stringify({
        enrolledCourses: this.payload.buyables,
        chargedPrice: this.payload.purchasePrice
      }));
    } else if (typeof client.onEnrolled === 'function') {
      client.onEnrolled(JSON.stringify(this.payload.buyables));
    }
  }
}
//# sourceMappingURL=on-enrolled-message.js.map